module.exports = __webpack_public_path__ + "img/offer-bonus.9bacdac1.svg";